import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import { toast } from "react-toastify";
import Modal from "react-modal";
import moment from "moment";

const AgronomyDetailForm = (props) => {
  const frmRef = useRef({});
  const [filterdData, setFilterdData] = useState("");
  const [agronomyId, setagronomyId] = useState("");
  const [farmerName, setfarmerName] = useState("");
  const [executiveName, setExecutiveName] = useState("");
  const [plotName, setplotName] = useState("");
  const [cropId, setcropId] = useState("");
  const [contractId, setContractId] = useState("");
  const [cropName, setcropName] = useState("");
  const [varietyName, setvarietyName] = useState("");
  const [irrigationDate, setIrrigationDate] = useState("");
  const [fieldOperationDescription, setfieldOperationDescription] =
    useState("");
  const [estimateYield, setEstimateYield] = useState("");
  const [plantCount, setplantCount] = useState("");
  const [averageLeavesPerPlant, setaverageLeavesPerPlant] = useState("");
  const [description, setdescription] = useState("");
  const [transplantedArea, settransplantedArea] = useState("");
  const [affectedArea, setaffectedArea] = useState("");
  const [affectedAreaUnitId, setaffectedAreaUnitId] = useState("");
  const [affectedAreaUnit, setaffectedAreaUnit] = useState("");
  const [recommendation, setrecommendation] = useState("");

  const [itemList, setItemList] = useState([]);
  const [products, setProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState("");
  const [availableUnits, setAvailableUnits] = useState([]);
  const [selectedUnit, setSelectedUnit] = useState("");
  const [quantity, setQuantity] = useState("");

  const [activities, setActivities] = useState([]);
  const [selectedFieldOperation, setSelectedFieldOperation] = useState({
    id: null,
    name: "",
  });

  const [diseases, setDisease] = useState([]);
  const [selectedDisease, setSelectedDisease] = useState("");

  const [images, setImages] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  const sowingMethod = [
    "Broadcast seeding",
    "Flat sowing",
    "Line sowing",
    "Point seeding",
    "Seed drill",
    "Stripe seeding",
  ];

  const seedSource = [
    "Breeder Seed",
    "Certified Seed",
    "Farmers Seed",
    "Foundation Seed",
    "Registered Seed",
  ];

  const landPreparationType = [
    "Conservation Tillage",
    "Conventional Tillage",
    "Zero Tillage",
    "Double Harrowing",
    "Harrowing & Ploughing",
    "Animal traction",
    "Manual (by hoe)",
    "Power Tiller",
    "None"
  ];

  const [selectedSowingMethod, setSelectedSowingMethod] = useState("");
  const [selectedSeedSource, setSelectedSeedSource] = useState("");
  const [selectedLandPrepType, setSelectedLandPrepType] = useState("");

  const handleSowingMethodChange = (event) => {
    setSelectedSowingMethod(event.target.value);
  };

  const handleSeedSourceChange = (event) => {
    setSelectedSeedSource(event.target.value);
  };

  const handleLandPrepTypeChange = (event) => {
    setSelectedLandPrepType(event.target.value);
  };

  const currentDate = new Date().toISOString().slice(0, 10);

  // const [selectedDate, setSelectedDate] = useState(
  //   new Date().toISOString().substr(0, 10)
  // );
  // const handleDateChange = (e) => {
  //   setSelectedDate(e.target.value);
  // };

  const [selectedAgroDate, setSelectedAgroDate] = useState(
    new Date().toISOString().substr(0, 10)
  );
  const handleAgroDateChange = (e) => {
    setSelectedAgroDate(e.target.value);
  };

  const [sowingDate, setSowingDate] = useState(
    new Date().toISOString().substr(0, 10)
  );
  const handleSowingDateChange = (e) => {
    setSowingDate(e.target.value);
  };

  const prevImage = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? imageGroups.length - 1 : prevIndex - 1
    );
  };

  const nextImage = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === imageGroups.length - 1 ? 0 : prevIndex + 1
    );
  };
  const imageGroups = [];
  for (let i = 0; i < images.length; i += 4) {
    imageGroups.push(images.slice(i, i + 4));
  }

  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
      top: 0,
    },
    content: {
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      maxWidth: "80%",
      width: "400px",
      height: "85%",
      minHeight: "auto",
      overflow: "auto",
      border: "5px solid #96dc00",
    },
  };
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const { sendRequest: getFertilizer } = useHttp();

  useEffect(() => {
    const fetchFertilizerData = () => {
      getFertilizer(
        {
          url: `/api/fillAgroFertlizerSeedProductList/?orgId=${localStorage.getItem(
            "orgId"
          )}`,
        },
        (res) => {
          if (res) {
            setProducts(res);
          }
        }
      );
    };

    fetchFertilizerData();
  }, []);

  const handleFormSubmit = (e) => {
    e.preventDefault();
    if (!selectedProduct || !selectedUnit || !quantity) {
      toast.error("Please fill all fields.");
      return;
    }
    const selectedProductData = products.find(
      (p) => p.productName === selectedProduct
    );
    const newItem = {
      productId: selectedProductData.productId,
      productType: selectedProductData.productTypeName,
      productName: selectedProduct,
      quantity,
      unit: selectedUnit,
    };

    setItemList([...itemList, newItem]);
    setSelectedProduct("");
    setAvailableUnits([]);
    setSelectedUnit("");
    setQuantity("");
    closeModal();
  };

  const { sendRequest: getFieldOperations } = useHttp();

  useEffect(() => {
    const fetchFieldOperations = () => {
      getFieldOperations(
        {
          url: `/api/farmActivity/?orgId=${localStorage.getItem("orgId")}`,
        },
        (res) => {
          if (res) {
            setActivities(res);
          }
        }
      );
    };

    fetchFieldOperations();
  }, [getFieldOperations]);

  const handleChangeFieldOperation = (event) => {
    const selectedName = event.target.value;
    const selectedOption = activities.find(
      (activity) => activity.fieldActivityName === selectedName
    );

    setSelectedFieldOperation({
      id: selectedOption?.fieldActivityId || null,
      name: selectedName,
    });
  };

  const { sendRequest: getDiseasesInsectsPest } = useHttp();

  useEffect(() => {
    const DiseasesInsectsPestObservation = () => {
      getDiseasesInsectsPest(
        {
          url: `/api/insectdiseasepest/?orgId=${localStorage.getItem("orgId")}`,
        },
        (res) => {
          if (res) {
            setDisease(res);
          }
        }
      );
    };

    DiseasesInsectsPestObservation();
  }, [getDiseasesInsectsPest]);

  const handleChangeDisease = (event) => {
    const selectedName = event.target.value;
    const selectedOption = diseases.find(
      (disease) => disease.insectDiseasePestName === selectedName
    );

    setSelectedDisease({
      id: selectedOption?.insectDiseasePestId || null,
      name: selectedName,
    });
  };

  const { sendRequest: putAgronomyData } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault();

    // const formatToBackendDate = (date) => {
    //   const [year, month, day] = date.split("-");
    //   return `${day}/${month}/${year}`;
    // };

    // const formatIrrigationDate = (date) => {
    //   const [year, month, day] = date.split("-");
    //   return `${day}/${month}/${year}`;
    // };


    // const formattetSowingDate = formatToBackendDate(sowingDate);
    // const formattedAgroDate = formatToBackendDate(selectedAgroDate);
    //  const formattedIrrigationDate = formatToBackendDate(irrigationDate);

    const formattedAgroFertilizers = JSON.stringify(
      itemList.map((item) => ({
        fertilizerId: item.productId,
        fertilizerName: item.productName,
        quantity: parseFloat(item.quantity),
        unit: item.unit,
        date: moment(selectedAgroDate).format("DD/MM/YYYY"),
        phi: 14,
      }))
    );

    const data = {
      createdBy: parseInt(localStorage.getItem("id")),
      orgId: parseInt(localStorage.getItem("orgId")),
      cropId: cropId,
      contractId: contractId,
      date: moment(sowingDate).format("DD/MM/YYYY"),
      agroFertilizers: formattedAgroFertilizers,
      description: description,
      recommendation: recommendation,
      fieldOperationId: selectedFieldOperation.id,
      irrigationDate: moment(irrigationDate).format("DD/MM/YYYY"),
      fieldOperationDescription: fieldOperationDescription,
      estimateYield: estimateYield,
      transplantedArea: transplantedArea,
      plantCount: plantCount,
      averageLeavesPerPlant: averageLeavesPerPlant,
      insectDiseasePestId: selectedDisease.id,
      affectedArea: affectedArea,
      affectedAreaUnitId: affectedAreaUnitId,
      sowingMethod: selectedSowingMethod,
      seedSource: selectedSeedSource,
      landPreparationType: selectedLandPrepType,
    };

    console.log("data", data);

    if (props.update) {
      data["agronomyId"] = props.update.agronomyId;
    }

    putAgronomyData(
      {
        url: "/api/farmerCropObservationViewList/",
        method: props.update ? "PUT" : "POST",
        body: data,
      },
      (res) => {
        toast.success(`Sowing Details ${props.update ? "Updated" : "Added"} Successfully`);
        props.addForm(false);
      },
      (error) => {
        toast.error(error || "Something went wrong");
        console.log(error);
      }
    );
  };

  useEffect(() => {
    if (props.update && products.length > 0) {
      // const sowingDate = props.update.date.split(" ")[0];
      // const [day, month, year] = sowingDate.split("/");
      // const formattedDate = `${year}-${month}-${day}`;
      setSowingDate(props.update.date);

      setfarmerName(props.update.farmerName);
      setExecutiveName(props.update.executiveName);
      setplotName(props.update.plotName);
      setcropId(props.update.cropId);
      setcropName(props.update.cropName);
      setContractId(props.update.contractId);
      setvarietyName(props.update.varietyName);

      setSelectedFieldOperation({
        id: props.update.fieldOperationId,
        name: props.update.fieldOperationName,
      });

      console.log(props.update.irrigationDate);

      // const irrigationDate = props.update.irrigationDate.split(" ")[0];
      // const [DD, MM, YYYY] = irrigationDate?.split("/");
      // const iDate = `${YYYY}-${MM}-${DD}`;
      // setIrrigationDate(iDate);
      setIrrigationDate(props.update.irrigationDate);

      setfieldOperationDescription(props.update.fieldOperationDescription);
      setEstimateYield(props.update.estimateYield);
      settransplantedArea(props.update.transplantedArea);
      setSelectedSowingMethod(props.update.sowingMethod);
      setSelectedSeedSource(props.update.seedSource);
      setSelectedLandPrepType(props.update.landPreparationType);
      setplantCount(props.update.plantCount);
      setaverageLeavesPerPlant(props.update.averageLeavesPerPlant);
      setdescription(props.update.description);

      setSelectedDisease({
        id: props.update.insectDiseasePestId,
        name: props.update.insectDiseasePestName,
      });
      setaffectedArea(props.update.affectedArea);
      setaffectedAreaUnit(props.update.affectedAreaUnit);
      setaffectedAreaUnitId(props.update.affectedAreaUnitId);
      setrecommendation(props.update.recommendation);

      const agroFertilizers = JSON.parse(props.update.agroFertilizers);
      const formattedForTable = agroFertilizers.map((item) => {
        const matchingProduct = products.find(
          (product) => product.productName === item.fertilizerName
        );
        return {
          productType: matchingProduct?.productTypeName || "N/A",
          productName: item.fertilizerName,
          productId: item.fertilizerId || null,
          quantity: item.quantity,
          unit: item.unit,
        };
      });
      setItemList(formattedForTable);

      const cropObservationObj = JSON.parse(props.update.cropObservation);
      const imageUrls = JSON.parse(
        cropObservationObj.cropObservationAttachment
      ).map(
        (item) => `${process.env.REACT_APP_FILE_URL}${item.urlAttachments}`
      );
      setImages(imageUrls);
    }
  }, [props.update, products]);

  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const offset = currentPage * itemsPerPage;
  const displayedItems =
    filterdData && filterdData.slice(offset, offset + itemsPerPage);

  return (
    <>
      <div className="content-wrapper">
        <div>&nbsp;</div>
        <section className="content">
          <form style={{ margin: "10px" }} onSubmit={submitHandler}>
            <div className="container-fluid">
              {/* SELECT2 EXAMPLE */}
              <div className="card card-default">
                <div className="card-header">
                  <h3 className="card-title">Edit Sowing Detail</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Sowing Date</label>
                        <input
                          type={"date"}
                          id={"sowingDate"}
                          required
                          ref={(el) => (frmRef.current["sowingDate"] = el)}
                          className="form-control"
                          max={currentDate}
                          value={sowingDate}
                          onChange={handleSowingDateChange}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Farmer name</label>
                        <input
                          type={"text"}
                          id={"farmerName"}
                          required
                          className="form-control"
                          readOnly={props.update}
                          value={farmerName}
                          onChange={(e) => {
                            setfarmerName(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Field Executive</label>
                        <input
                          type={"text"}
                          id={"executiveName"}
                          required
                          className="form-control"
                          readOnly={props.update}
                          value={executiveName}
                          onChange={(e) => {
                            setExecutiveName(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Plot name</label>
                        <input
                          type={"text"}
                          id={"plotName"}
                          required
                          className="form-control"
                          readOnly={props.update}
                          value={plotName}
                          onChange={(e) => {
                            setplotName(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Crop name</label>
                        <input
                          type={"text"}
                          id={"cropName"}
                          required
                          className="form-control"
                          readOnly={props.update}
                          value={cropName}
                          onChange={(e) => {
                            setcropName(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Variety name</label>
                        <input
                          type={"text"}
                          id={"varietyName"}
                          required
                          className="form-control"
                          readOnly={props.update}
                          value={varietyName}
                          onChange={(e) => {
                            setvarietyName(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Irrigation Date</label>
                        <input
                          type={"date"}
                          id={"irrigationDate"}
                          required
                          ref={(el) => (frmRef.current["irrigationDate"] = el)}
                          max={currentDate}
                          className="form-control"
                          value={irrigationDate}
                          onChange={(e) => {
                            setIrrigationDate(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Field Operation Description</label>
                        <input
                          type={"text"}
                          id={"fieldOperationDescription"}
                          required
                          className="form-control"
                          value={fieldOperationDescription}
                          onChange={(e) => {
                            setfieldOperationDescription(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Sowing/Transplanted Area</label>
                        <input
                          type={"text"}
                          id={"transplantedArea"}
                          required
                          className="form-control"
                          value={transplantedArea}
                          onChange={(e) => {
                            settransplantedArea(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Sowing Method</label>
                        <select
                          id="sowingMethod"
                          className="form-control"
                          required
                          value={selectedSowingMethod}
                          onChange={handleSowingMethodChange}
                        >
                          <option value="">Select</option>
                          {sowingMethod.map((method, index) => (
                            <option key={index} value={method}>
                              {method}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Seed Source</label>
                        <select
                          id="seedSource"
                          className="form-control"
                          required
                          value={selectedSeedSource}
                          onChange={handleSeedSourceChange}
                        >
                          <option value="">Select</option>
                          {seedSource.map((source, index) => (
                            <option key={index} value={source}>
                              {source}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Land Preparation Type</label>
                        <select
                          id="landPreparationType"
                          className="form-control"
                          required
                          value={selectedLandPrepType}
                          onChange={handleLandPrepTypeChange}
                        >
                          <option value="">Select</option>
                          {landPreparationType.map((prepType, index) => (
                            <option key={index} value={prepType}>
                              {prepType}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Estimate Yield(Kg)</label>
                        <input
                          type={"text"}
                          id={"estimateYield"}
                          required
                          className="form-control"
                          value={estimateYield}
                          readOnly
                          // onChange={(e) => {
                          //   setEstimateYield(e.target.value);
                          // }}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Description</label>
                        <input
                          type={"text"}
                          id={"description"}
                          required
                          className="form-control"
                          value={description}
                          onChange={(e) => {
                            setdescription(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Recommendations</label>
                        <input
                          type={"text"}
                          id={"recommendation"}
                          required
                          className="form-control"
                          value={recommendation}
                          onChange={(e) => {
                            setrecommendation(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div>
                    <div className="col-md-10">
                      <div className="row">
                        <div className="col-md-4">
                          <label>Agro-Chemical/Fertilizer Detail</label>
                        </div>
                        <div className="col-md-2"></div>
                        <div className="col-md-3"></div>
                        <div className="col-md-1">
                          <button
                            type="button"
                            className="btn-success"
                            data-toggle="modal"
                            data-target="#modal-sm"
                            onClick={openModal}
                          >
                            +
                          </button>
                        </div>
                      </div>
                      <div className="row">
                        <table className="table table-bordered text-center">
                          <thead>
                            <tr className="tableheaderrowview">
                              <th>Sr.No</th>
                              <th>Product Type</th>
                              <th>Product Name</th>
                              <th>Quantity</th>
                              <th>Unit</th>
                            </tr>
                          </thead>
                          <tbody>
                            {itemList.length > 0 ? (
                              itemList.map((items, index) => (
                                <tr key={index}>
                                  <td>{index + 1}</td>
                                  <td>{items.productType}</td>
                                  <td>{items.productName}</td>
                                  <td>{items.quantity}</td>
                                  <td>{items.unit}</td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="5">No data present</td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-3">
                      <div className="form-group">
                        <label>Observation Photos:</label>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-12">
                      <div
                        id="carouselExampleCustom"
                        className="carousel slide"
                        style={{ position: "relative" }}
                      >
                        <div className="carousel-inner">
                          {imageGroups.length > 0 ? (
                            imageGroups.map((group, index) => (
                              <div
                                key={index}
                                className={`carousel-item ${
                                  index === currentIndex ? "active" : ""
                                }`}
                              >
                                <div className="row w-50px">
                                  {group.map((image, idx) => (
                                    <div key={idx} className="col-3">
                                      <img
                                        src={image}
                                        className="d-block w-100"
                                        alt={`Observation ${
                                          index * 4 + idx + 1
                                        }`}
                                        style={{
                                          borderRadius: "5px",
                                          objectFit: "fill",
                                          height: "300px",
                                          width: "100px",
                                        }}
                                      />
                                    </div>
                                  ))}
                                </div>
                              </div>
                            ))
                          ) : (
                            <p style={{ textAlign: "center" }}>
                              No images available
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4"></div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-1">
                      {" "}
                      <button
                        className="btn  btn-primary mx-2 my-2"
                        type="submit"
                      >
                        Submit
                      </button>
                    </div>
                    <div className="col-md-1"></div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-4"></div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>

      <Modal
        isOpen={isModalOpen}
        style={customModalStyles}
        contentLabel="Example Modal"
      >
        <div>
          <form onSubmit={handleFormSubmit} className="text-center">
            <h3 className="card-title">Add Agro-Chemical/Fertilizer</h3>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={closeModal}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>

            <div className="row">
              <div className="col-md-1"></div>
              <div className="col-md-10">
                <div className="form-group">
                  <label>Agro-Chemical parameter</label>
                  <select
                    id="agroChemical"
                    className="form-control"
                    required
                    value={selectedProduct}
                    onChange={(e) => {
                      const selected = e.target.value;
                      setSelectedProduct(selected);

                      const product = products.find(
                        (p) => p.productName === selected
                      );
                      setAvailableUnits(product ? [product.unitName] : []);
                      setSelectedUnit("");
                    }}
                  >
                    <option value="">Select Product</option>
                    {products.map((product, index) => (
                      <option key={index} value={product.productName}>
                        {product.productName}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="col-md-1"></div>
            </div>

            <div className="row">
              <div className="col-md-1"></div>
              <div className="col-md-5">
                <div className="form-group">
                  <label>Quantity</label>
                  <input
                    type={"text"}
                    id={"quantity"}
                    required
                    className="form-control"
                    value={quantity}
                    onChange={(e) => {
                      setQuantity(e.target.value);
                    }}
                  />
                </div>
              </div>
              <div className="col-md-5">
                <div className="form-group">
                  <label>Unit</label>
                  <select
                    id="unit"
                    className="form-control"
                    required
                    value={selectedUnit}
                    onChange={(e) => setSelectedUnit(e.target.value)}
                    disabled={!selectedProduct}
                  >
                    <option value="">Select Unit</option>
                    {availableUnits.map((unit, index) => (
                      <option key={index} value={unit}>
                        {unit}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="col-md-1"></div>
            </div>

            <div className="row">
              <div className="col-md-1"></div>
              <div className="col-md-10">
                <div className="form-group">
                  <label>Date</label>
                  <input
                    type={"date"}
                    id={"agroDate"}
                    required
                    ref={(el) => (frmRef.current["agroDate"] = el)}
                    className="form-control"
                    max={currentDate}
                    value={selectedAgroDate}
                    onChange={handleAgroDateChange}
                  />
                </div>
              </div>
              <div className="col-md-1"></div>
            </div>
            <div className="text-center">
              <button className="btn  btn-primary mx-2 my-2" type="submit">
                submit
              </button>
            </div>
          </form>
        </div>
      </Modal>
    </>
  );
};

export default AgronomyDetailForm;
